import { invoke } from '@tauri-apps/api/core';
import { emit, listen } from '@tauri-apps/api/event';
import { AGENT_CHAT_HISTORY_UPDATED_EVENT, DEFAULT_QUICK_ENTRY_ACCELERATOR, QUICK_ENTRY_ACTION_EVENT } from 'utils/quick-entry';
import { isTauriApp } from 'utils/is-tauri';
export const configureQuickEntryNative = async (prefs)=>{
    if (!isTauriApp()) {
        return;
    }
    // Shortcut + enable are fixed product defaults.
    await invoke('configure_quick_entry', {
        enabled: true,
        accelerator: DEFAULT_QUICK_ENTRY_ACCELERATOR,
        runInBackground: prefs.runInBackground
    });
};
export const getQuickEntryStatus = async ()=>{
    if (!isTauriApp()) {
        return null;
    }
    return invoke('get_quick_entry_status');
};
export const hideQuickEntryWindow = async ()=>{
    if (!isTauriApp()) {
        return;
    }
    await invoke('quick_entry_hide');
};
export const focusMainWindow = async ()=>{
    if (!isTauriApp()) {
        return;
    }
    await invoke('focus_main_window');
};
export const emitQuickEntryAction = async (action)=>{
    if (!isTauriApp()) {
        return;
    }
    await emit(QUICK_ENTRY_ACTION_EVENT, action);
};
export const listenQuickEntryActions = async (handler)=>{
    return listen(QUICK_ENTRY_ACTION_EVENT, (event)=>{
        handler(event.payload);
    });
};
export const emitAgentChatHistoryUpdated = async (payload)=>{
    if (!isTauriApp()) {
        return;
    }
    await emit(AGENT_CHAT_HISTORY_UPDATED_EVENT, payload);
};
export const listenAgentChatHistoryUpdated = async (handler)=>{
    return listen(AGENT_CHAT_HISTORY_UPDATED_EVENT, (event)=>{
        handler(event.payload);
    });
};
